<script>
import {defineComponent} from 'vue'
import VueGoogleAutocomplete from "vue-google-autocomplete";
import i18n from "@/i18n";


export default defineComponent({
  name: "AddressEdit",
  props: {
    mapId: {
      type: String,
      required: true
    }
  },
  components: {
    VueGoogleAutocomplete
  },
  data() {
    return {
      blank_address: {
        country: "France",
        countryiso2: "FR",
        exported_address: "",
        formatted_address:"",
        id: null,
        latitude:null,
        locality: null,
        longitude: null,
        postal_code: "",
        route: "",
        route2: null,
        short_postal_code: null,
        street_number:null,
      }
    }
  },
  computed: {
    establishment: {
      get() {
        const _establishment = this.$store.state.contacts.editableEstablishment;
        if (_establishment.place === null) {
          _establishment.place= this.blank_address
        }
        return _establishment;
      },
      set(value) {
        this.$store.commit("editableEstablishment", value);
      }
    },
    googleAutoCompleteKey: {
      get() {
        return this.$store.state.contacts.googleAutoCompleteKey;
      },
      set(value) {
        this.$store.commit("googleAutoCompleteKey", value);
      }
    },
    monitor() {
      return {
        renderGA: this.$store.state.contacts.renderGA
      }
    }
  },
  watch: {
    monitor: {
      handler() {
        if (!Object.values(this.monitor).includes(true)) {
          //console.log("Removing Google Autocomplete component");
          document.querySelector('.pac-container')?.remove();
        }
        this.clearGA();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onAddressChange(place) {
      const _establishment = Object.assign({}, this.establishment);
      _establishment.place = place;
      this.establishment = Object.assign({}, _establishment);
      this.clearGA();
    },
    setZindex() {
      const element = document.querySelector('.pac-container');
      if (element)
        element.style.zIndex = '1150';
    },
    clearGA() {
      this.$nextTick(() => {
        if  (this.$refs.autocomplete)
          this.$refs.autocomplete.clear();
      });
    }
  },
  beforeMount() {
    this.googleAutoCompleteKey += 1;
  }
})
</script>

<template>
  <form
      ref="form_edit_address"
      autocomplete="nope"
  >
    <b-container>
      <!-- google place  -->
      <b-row>
        <b-col cols="12" class="border rounded">
          <b-container class="p-0">
            <b-row class="p-0" >
              <b-col cols="1" style="margin-top: -0.1rem">
                <span class="d-none d-sm-block py-1" style="font-size: 1rem"><b-icon icon="search" /></span>
              </b-col>
              <b-col cols="11" class="pl-lg-0 pl-0">
                <vue-google-autocomplete
                    v-if="$store.state.contacts.renderGA"
                    id="map"
                    ref="autocomplete"
                    :placeholder="$t('Rechercher une adresse')"
                    style="border-color: transparent !important; color: var(--black); height: auto; width: 100%; border: 0; min-height: 1.5rem; padding-bottom: 0.3rem; padding-top: 0.36rem"
                    :country="['fr']"
                    autocomplete="nope"
                    @placechanged="onAddressChange"
                    @inputChange="setZindex"
                />
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <!-- street number & route -->
      <b-row class="mt-3">
        <b-col cols="3" sm="2" class="px-0 pr-2">
          <b-form-input
              v-model="establishment.place.street_number"
              size="sm"
              name="street_number"
              :placeholder="$t('N°')"
              autocomplete="nope"
          />
        </b-col>
        <b-col cols="9" sm="10" class="px-0">
          <b-form-input
              v-model="establishment.place.route"
              size="sm"
              :placeholder="$t('Adresse')"
              name="address"
              autocomplete="nope"
          />
        </b-col>
      </b-row>
      <!-- route 2 -->
      <b-row class="mt-3">
        <b-col cols="12" class="px-0">
          <b-form-input
              v-model="establishment.place.route2"
              size="sm"
              :placeholder="$t('Adresse (suite)')"
              name="address2"
              autocomplete="nope"
          />
        </b-col>
      </b-row>
      <!-- postal_code & locality & countru -->
      <b-row class="mt-3 w-full">
        <b-col cols="4"  class="px-0">
          <b-form-input
              v-model="establishment.place.postal_code"
              size="sm"
              :placeholder="$t('Code postal')"
              name="postal_code"
              autocomplete="nope"
          />
        </b-col>
        <b-col cols="4" class="px-2">
          <b-form-input
              v-model="establishment.place.locality"
              size="sm"
              :placeholder="$t('Ville')"
              name="locality"
              autocomplete="nope"
          />
        </b-col>
        <b-col cols="4" class="px-0">
          <b-form-input
              v-model="establishment.place.country"
              size="sm"
              :placeholder="$t('Pays')"
              name="country"
              autocomplete="nope"
          />
        </b-col>
      </b-row>
    </b-container>
  </form>
</template>

<style scoped lang="scss">
  .pac-container {
    z-index: 1050 !important;
  }
</style>